import { createContext } from "react";

const LoginContext = createContext({
  login: {
    name: "Prajval Sorate",
   
  },
});

export default LoginContext;